<template>
  <div class="navbar_wrap">
    <div class="navbar_container">
      <div class="navbar_left">
        <router-link to="/home">
          <img :src="config.logo1" alt="慈福" />
        </router-link>
      </div>
      <div class="navbar_right">
        <el-menu
          v-if="platform == 'web'"
          :default-active="menuActive"
          class="el_menu_demo"
          mode="horizontal"
          router
          background-color="rgba(0,0,0,0)"
          text-color="#663301"
          active-text-color="#663301"
          @select="changeCurrentPage"
        >
          <el-menu-item index="/home" class="menu_item"  popper-class="drop-down-menu" :popper-append-to-body="false" :show-timeout="0" :hide-timeout="0">
            <template slot="title">
              <span>首页</span>
            </template>
          </el-menu-item>
          <el-submenu index="/aboutUs" class="menu_item" popper-class="drop-down-menu" :popper-append-to-body="false" :show-timeout="0" :hide-timeout="0">
            <template slot="title">
              <span @click="handleClickMenu('aboutUs')">关于慈福</span>
            </template>
            <el-menu-item v-for="(item, jndex) in about_cifu" :key="jndex" :index="`/about/${item.id}`" class="menu_item">{{ item.name }}</el-menu-item>
          </el-submenu>
          <el-submenu index="/project" class="menu_item" popper-class="drop-down-menu" :popper-append-to-body="false" :show-timeout="0" :hide-timeout="0">
            <template slot="title">
              <span @click="handleClickMenu('project')">慈福项目</span>
            </template>
            <el-menu-item v-for="(item, jndex) in cateList" :key="jndex" :index="`/project/${jndex + 1}`" class="menu_item">{{ item.title }}</el-menu-item>
          </el-submenu>
          <el-submenu index="/donate" class="menu_item" popper-class="drop-down-menu" :popper-append-to-body="false" :show-timeout="0" :hide-timeout="0">
            <template slot="title">
              <span @click="handleClickMenu('donate')">爱心捐赠</span>
            </template>
            <el-menu-item index="/donate/1" class="menu_item">捐款方式</el-menu-item>
            <el-menu-item index="/donate/2" class="menu_item">捐赠记录</el-menu-item>
            <el-menu-item index="/donate/3" class="menu_item">票据申领</el-menu-item>
            <el-menu-item index="/donate/4" class="menu_item">证书申领</el-menu-item>
            <el-menu-item index="/donate/5" class="menu_item">抵扣说明</el-menu-item>
            <el-menu-item index="/donate/6" class="menu_item" v-if="aixin_status == 1">爱心传递</el-menu-item>
          </el-submenu>
          <el-submenu index="/news" class="menu_item" popper-class="drop-down-menu" :popper-append-to-body="false" :show-timeout="0" :hide-timeout="0">
            <template slot="title">
              <span @click="handleClickMenu('news')">慈福新闻</span>
            </template>
            <el-menu-item
              v-for="(item, jndex) in newsLei"
              :key="jndex"
              class="menu_item"
              :index="`/news/${jndex + 1}`"
            >{{ item.name }}</el-menu-item>
          </el-submenu>
          <el-submenu index="/information" class="menu_item" popper-class="drop-down-menu" :popper-append-to-body="false" :show-timeout="0" :hide-timeout="0">
            <template slot="title">
              <span @click="handleClickMenu('information')">信息公开</span>
            </template>
            <el-menu-item index="/information/5" class="menu_item">资质证书</el-menu-item>
            <el-menu-item v-for="(item, jndex) in reportList" :key="jndex" :index="`/information/${item.id}`" class="menu_item">{{ item.title }}</el-menu-item>
            <el-menu-item index="/information/6" class="menu_item">免税批文</el-menu-item>
          </el-submenu>
          <el-submenu index="/partyBuilding" class="menu_item" popper-class="drop-down-menu" :popper-append-to-body="false" :show-timeout="0" :hide-timeout="0">
              <template slot="title">
                <span @click="handleClickMenu('partyBuilding')">党建专栏</span>
              </template>
              <el-menu-item :index="`/partyBuilding/${index+1}`" class="menu_item" v-for="(item, index) in fenlei" :key="index">{{item.name}}</el-menu-item>
            </el-submenu>
          <el-submenu index="/joinUs" class="menu_item" popper-class="drop-down-menu" :popper-append-to-body="false" :show-timeout="0" :hide-timeout="0">
            <template slot="title">
              <span @click="handleClickMenu('joinUs')">加入我们</span>
            </template>
            <el-menu-item index="/joinUs/1" class="menu_item">人员招聘</el-menu-item>
            <el-menu-item index="/joinUs/2" class="menu_item">志愿者招聘</el-menu-item>
            <el-menu-item index="/joinUs/3" class="menu_item">联系我们</el-menu-item>
        </el-submenu>
        </el-menu>
        <div class="menu-icon" v-if="platform == 'mobile'" @click="toggleMenu">
          <i class="el-icon-menu" />
        </div>
        <div class="user" v-if="token.length > 0">
          <span class="user-name">{{ userInfo.nickname || "无名爱心人士" }}</span>
          <el-divider direction="vertical" />
          <el-dropdown @command="handleClick">
            <div class="user-head">
              <el-image  class="user-head-img" :src="userInfo.avatar" fit="fit"/>
            </div>
            <template #dropdown>
              <el-dropdown-menu class="custom-dropdown">
                <el-dropdown-item command="personalCenter">个人中心</el-dropdown-item>
                <el-dropdown-item command="logout">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
        <div class="login" v-else>
          <router-link to="/login" class="btn">登录</router-link>
          <router-link to="/register" class="btn">注册</router-link>
        </div>
      </div>
    </div>
    <!-- 移动端菜单 (新增) -->
    <transition name="slide">
      <div class="mobile-menu" v-show="mobileMenuVisible">
        <div class="menu-content">
          <el-menu
            :default-active="menuActive"
            class="el-menu-mobile"
            router
            mode="vertical"
            unique-opened
            text-color="#663301"
            active-text-color="#663301"
            @select="changeCurrentPage"
          >
            <el-menu-item index="/home" class="menu_item" @click="toggleMenu">首页</el-menu-item>
            <el-submenu index="/aboutUs" class="menu_item" popper-class="drop-down-menu" :popper-append-to-body="false" :show-timeout="0" :hide-timeout="0">
              <template slot="title">
                <span @click="handleClickMenu('aboutUs')">关于慈福</span>
              </template>
              <el-menu-item v-for="(item, jndex) in about_cifu" :key="jndex" :index="`/about/${item.id}`" class="menu_item" @click="toggleMenu">{{ item.name }}</el-menu-item>
            </el-submenu>
            <el-submenu index="/project" class="menu_item" popper-class="drop-down-menu" :popper-append-to-body="false" :show-timeout="0" :hide-timeout="0">
              <template slot="title">
                <span @click="handleClickMenu('project')">慈福项目</span>
              </template>
              <el-menu-item v-for="(item, jndex) in cateList" :key="jndex" :index="`/project/${jndex + 1}`" class="menu_item" @click="toggleMenu">{{ item.title }}</el-menu-item>
            </el-submenu>
            <el-submenu index="/donate" class="menu_item" popper-class="drop-down-menu" :popper-append-to-body="false" :show-timeout="0" :hide-timeout="0">
              <template slot="title">
                <span @click="handleClickMenu('donate')">爱心捐赠</span>
              </template>
              <el-menu-item index="/donate/1" class="menu_item" @click="toggleMenu">捐款方式</el-menu-item>
              <el-menu-item index="/donate/2" class="menu_item" @click="toggleMenu">捐赠记录</el-menu-item>
              <el-menu-item index="/donate/3" class="menu_item" @click="toggleMenu">票据申领</el-menu-item>
              <el-menu-item index="/donate/4" class="menu_item" @click="toggleMenu">证书申领</el-menu-item>
              <el-menu-item index="/donate/5" class="menu_item" @click="toggleMenu">抵扣说明</el-menu-item>
              <el-menu-item index="/donate/6" class="menu_item" @click="toggleMenu">爱心传递</el-menu-item>
            </el-submenu>
            <el-submenu index="/news" class="menu_item" popper-class="drop-down-menu" :popper-append-to-body="false" :show-timeout="0" :hide-timeout="0">
              <template slot="title">
                <span @click="handleClickMenu('news')">慈福新闻</span>
              </template>
              <el-menu-item
                v-for="(item, jndex) in newsLei"
                :key="jndex"
                @click="toggleMenu"
                class="menu_item"
                :index="`/news/${jndex + 1}`"
              >{{ item.name }}</el-menu-item>
            </el-submenu>
            <el-submenu index="/information" class="menu_item" popper-class="drop-down-menu" :popper-append-to-body="false" :show-timeout="0" :hide-timeout="0">
              <template slot="title">
                <span @click="handleClickMenu('information')">信息公开</span>
              </template>
              <el-menu-item index="/information/5" class="menu_item" @click="toggleMenu">资质证书</el-menu-item>
              <el-menu-item v-for="(item, jndex) in reportList" :key="jndex" :index="`/information/${item.id}`" class="menu_item" @click="toggleMenu">{{ item.title }}</el-menu-item>
              <el-menu-item index="/information/6" class="menu_item" @click="toggleMenu">免税批文</el-menu-item>
              <el-menu-item index="/information/7" class="menu_item" @click="toggleMenu">信息公开说明</el-menu-item>
            </el-submenu>
            <el-submenu index="/partyBuilding" class="menu_item" popper-class="drop-down-menu" :popper-append-to-body="false" :show-timeout="0" :hide-timeout="0">
              <template slot="title">
                <span @click="handleClickMenu('partyBuilding')">党建专栏</span>
              </template>
              <el-menu-item :index="`/partyBuilding/${index+1}`" class="menu_item" v-for="(item, index) in fenlei" :key="index" @click="toggleMenu">{{item.name}}</el-menu-item>
            </el-submenu>
            <el-submenu index="/joinUs" class="menu_item" popper-class="drop-down-menu" :popper-append-to-body="false" :show-timeout="0" :hide-timeout="0">
              <template slot="title">
                <span @click="handleClickMenu('joinUs')">加入我们</span>
              </template>
              <el-menu-item index="/joinUs/1" class="menu_item" @click="toggleMenu">人员招聘</el-menu-item>
              <el-menu-item index="/joinUs/2" class="menu_item" @click="toggleMenu">志愿者招聘</el-menu-item>
              <el-menu-item index="/joinUs/3" class="menu_item" @click="toggleMenu">联系我们</el-menu-item>
            </el-submenu>
          </el-menu>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
import CifuAPI from "@/utils/api";
export default {
  data() {
    return {
      mobileMenuVisible: false, // 控制菜单显示状态
      fenlei: [],
      menuIndex: 'index',
      cateList: [],
      reportList: [],
      aixin_status: 1,
      about_cifu: [],
      newsLei: []
    };
  },
  computed: {
    ...mapState(["menuActive", "token", "userInfo", "platform", "config"]),
  },
  created() {
    this.getFenlei()
    this.getCateList()
    this.getReportType()
    this.getConfig()
    this.getNewsType()
  },
  watch: {
    $route: {
      handler(to) {
        if (to.path == "/projectDetail") {
          this.$store.dispatch("setMenuActive", `/project/${to.query.type}`);
        } else if (to.path == "/partyBuildingDetail") {
          this.$store.dispatch("setMenuActive", `/partyBuilding/${to.query.type}`);
        } else if (to.path == "/newsDetail") {
          this.$store.dispatch("setMenuActive", `/news/${to.query.type}`);
        } else if (to.path == "/informationDetail") {
          this.$store.dispatch("setMenuActive", `/information/${to.query.type}`);
        } else if (to.path == "/donateDetail") {
          this.$store.dispatch("setMenuActive", `/donate/${to.query.type}`);
        } else {
          this.$store.dispatch("setMenuActive", to.fullPath);
        }
      },
      immediate: true, // 组件创建时立即执行一次
    },
  },
  methods: {
    handleClickMenu(e) {
      if (e == 'aboutUs') {
        this.$router.push(`/about/${this.about_cifu[0].id}`)
      }
      if (e == 'project') {
        this.$router.push('/project/1')
      }
      if (e == 'donate') {
        this.$router.push('/donate/1')
      }
      if (e == 'news') {
        this.$router.push('/news/1')
      }
      if (e == 'information') {
        this.$router.push('/information/5')
      }
      if (e == 'partyBuilding') {
        this.$router.push('/partyBuilding/1')
      }
      if (e == 'joinUs') {
        this.$router.push('/joinUs/1')
      }
    },
    async getReportType() {
      let res = await CifuAPI.getReportType()
      console.log(res)
      if (res.code == 1) {
        this.reportList = res.data
      }
      
    },
    async getNewsType() {
      let res = await CifuAPI.getArticleType({ model_type: "news" })
      console.log(res)
      if (res.code == 1) {
        this.newsLei = res.data
      }
    },
    async getFenlei() {
      let res = await CifuAPI.getArticleType({ model_type: "dzb_activity" })
      if (res.code == 1) {
        this.fenlei = res.data
      }
    },
    async getCateList() {
      let res = await CifuAPI.getCateList()
      console.log(res)
      if (res.code == 1) {
        this.cateList = res.data
      }
    },
    async getConfig() {
      let res = await CifuAPI.getConfig()
      if (res.code == 1) {
        this.aixin_status = res.data.aixin_status
        this.about_cifu = res.data.about_cifu
      }
    },
    toggleMenu() {
      this.mobileMenuVisible = !this.mobileMenuVisible;
    },
    changeCurrentPage(index) {
      console.log(index, 34234324)
      this.$store.dispatch("setMenuActive", index);
    },
    handleClick(command) {
      if (command == "logout") {
        this.$store.dispatch("logout");
      } else if (command == "personalCenter") {
        this.$router.push("/personalCenter");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.navbar_wrap {
  width: 100%;
  min-width: 1400px;
  height: 100px;
  padding: 0 20px;
  background: #fbce00;
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  // @media screen and (max-width: 768px) {
  //   height: 80px;
  //   min-width: auto; // 手机端不限制最小宽度
  // }
    .navbar_container {
      width: 100%;
      height: 100%;
      margin: 0 auto;
      display: flex;
      flex-wrap: nowrap;
      justify-content: center;
      min-width: 1400px; // 电脑端固定宽度
      // @media screen and (max-width: 768px) {
      //   justify-content: space-between;
      //   width: 100%; // 手机端自适应宽度
      // }
    .navbar_left {
      padding-top: 30px;
      padding-right: 60px;
      // @media screen and (max-width: 768px) {
      //   padding-top: 20px;
      //   padding-right: 0;
      // }
      img {
        flex: none;
        display: block;
        flex-shrink: 0;
        width: 107px;
        cursor: pointer;
        // @media screen and (max-width: 768px) {
        //   width: 80px;
        // }
      }
    }
    .navbar_right {
      height: 100%;
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      justify-content: flex-end;
      font-size: 20px;
      .el_menu_demo {
        border: none;
      }
      .menu_item {
        text-align: center;
        width: 120px !important;
        border: none !important;
        &:hover {
          width: 120px;
          text-align: center !important;
          position: relative;
          font-weight: 600;
          background: #fff !important;
          border: none !important;
          ::v-deep .el-submenu__title{
            border: none !important;
          }
          ::v-deep .el-submenu__title::after {
            position: absolute;
            left: 12px;
            bottom: 0;
            content: "";
            width: 89px;
            height: 3px;
            background-color: #fbce00;
            z-index: 3;
          }
        }
      }
      ::v-deep .el-submenu__title{
        padding: 0px;
      }
      .menu_item_action{
        text-align: center;
        width: 118px !important;
        border: none !important;
      }
      .user {
        display: flex;
        align-items: center;
        padding-left: 40px;
        &-name {
          font-size: 16px;
          color: #663301;
          // @media screen and (max-width: 768px) {
          //   font-size: 14px;
          //   white-space: nowrap;
          // }
        }
        ::v-deep .el-divider {
          margin: 0 25px;
          background-color: #663301;
          // @media screen and (max-width: 768px) {
          //   margin: 0 15px;
          // }
        }
        &-head {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 56px;
          height: 56px;
          border-radius: 50%;
          overflow: hidden;
          background:#fff;
          // @media screen and (max-width: 768px) {
          //   width: 40px;
          //   height: 40px;
          //   background:#fff;
          // }
          &-img{
            width: 46px;
            height: 46px;
            // @media screen and (max-width: 768px) {
            //   width: 30px;
            //   height: 30px;
            //   background:#fff;
            // }
          }
        }
      }
      .login {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 24px;
        .btn {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 80px;
          height: 42px;
          background: #fffae5;
          border: none;
          border-radius: 40px;
          font-size: 16px;
          color: #663301;
          & + .btn {
            margin-left: 10px;
          }
        }
      }
    }
  }
  .menu-icon {
    color: #fff;
  }
}
/* 新增移动端菜单样式 */
.mobile-menu {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  .menu-content {
    width: 70%;
    max-width: 300px;
    height: 100%;
    background: #fbce00;
    overflow-y: auto;
  }
}

/* 添加滑动动画 */
.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s ease;
}
.slide-enter,
.slide-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}

/* 调整移动端菜单样式 */
.el-menu-mobile {
  border-right: none;
  background-color: transparent;
  .el-menu-item,
  .el-submenu__title {
    height: 50px;
    line-height: 50px;
    color: #663301;
    &:hover {
      background-color: rgba(255, 255, 255, 0.3) !important;
      border: none !important;
    }
  }
  .el-submenu {
    .el-menu-item {
      padding-left: 40px !important;
      background-color: rgba(0, 0, 0, 0.05);
    }
  }
}

/* 调整菜单按钮样式 */
.menu-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  margin-left: 20px;
  cursor: pointer;
  i {
    font-size: 24px;
    color: #663301;
  }
}
</style>
<style lang="scss">
.navbar_right {
  .el-menu--horizontal {
    .el-menu-item {
      float: none;
      display: inline-block;
      font-size: 20px;
    }
    & > .el-menu-item.is-active {
      font-weight: bold;
    }
    & > .el-submenu {
      float: none;
      position: relative;
      display: inline-block;
      .el-submenu__icon-arrow {
        display: none !important;
      }
      .el-menu-item {
        font-size: 18px;
        color: #828282 !important;
        font-weight: normal;
        &:hover {
          color: #d60c18 !important;
          border: none !important;
        }
      }
    }
  }
  .el-submenu__title {
    font-size: 20px;
    // padding: 0 34px;
  }
  .el-menu--popup {
    width: 100%;
    min-width: 100%;
    box-shadow: none;
    .el-menu-item {
      min-width: 100%;
      width: 100%;
      text-align: center;
    }
  }
  .drop-down-menu {
    position: absolute !important;
    background-color: #fff;
  }
}
.custom-dropdown {
  .el-dropdown-menu {
    &__item {
      font-size: 18px;
      &:focus,
      &:not(.is-disabled):hover {
        background-color: #fff;
        border: none !important;
        color: #d60c18;
      }
    }
  }
}
</style>
